import { Helmet } from "react-helmet-async";
import styles from "./index.module.scss";
import HeaderView from "../../components/Header/HeaderView";
import Footer from "../../components/Footer/Footer";
import ReactMarkdown from "react-markdown";

export default function PrivacyPolicy() {
  return (
    <main className={styles.area}>
      <Helmet>
        <title>CatLogic | Политика конфиденциальности и обработки персональных данных</title>
        <link rel="canonical" href="https://www.catlogic.tech/privacy-policy" />
      </Helmet>
      <HeaderView />
      <div className={styles.header}>
        <h1>Политика конфиденциальности и обработки персональных данных</h1>
      </div>
      <div className={styles.content}>
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
      <Footer />
    </main>
  );
}

const content = `

## 1. Общие положения

**1.1.** Платформа **Stafflow**, владельцем которой является **ООО «Кэтлоджик»** (далее – Платформа), выступает уполномоченным лицом, осуществляющим обработку персональных данных по поручению операторов – организаций-заказчиков (работодателей).

**1.2.** Персональные данные пользователей обрабатываются исключительно с целью выполнения задач, порученных оператором (заказчиком платформы) в рамках предоставляемых услуг, а именно:
- ведения кадрового учета;
- осуществления процессов подбора и оценки персонала;
- проведения обучения и оценки компетенций;
- организации коммуникаций между сотрудниками.

**1.3.** Персональные данные, обрабатываемые Платформой, могут включать:
- фамилию, имя, отчество,
- дату рождения,
- контактные данные (телефон, email),
- сведения об образовании, трудовом стаже
- и другие сведения, необходимые для выполнения порученных задач.

## 2. Условия обработки персональных данных

**2.1.** Обработка персональных данных осуществляется исключительно по поручению операторов персональных данных (организаций-заказчиков услуг Платформы) на основании заключенных с ними договоров.

**2.2.** Персональные данные обрабатываются с согласия субъектов персональных данных, предоставленного оператору (организации-заказчику) в порядке, предусмотренном законодательством Республики Беларусь.

**2.3.** Срок обработки персональных данных ограничен периодом действия договоров с операторами и достижением целей, указанных в пункте 1.1 настоящей Политики.

## 3. Права субъектов персональных данных

**3.1.** Субъект персональных данных вправе:
- получать от операторов информацию об обработке своих персональных данных;
- требовать от операторов уточнения, обновления, блокирования или удаления своих персональных данных;
- отозвать согласие на обработку персональных данных, предоставленное операторам;
- обжаловать действия или бездействие операторов.

**3.2.** Реализация указанных прав осуществляется через оператора (организацию-заказчика), от имени и в интересах которого Платформа обрабатывает персональные данные.

## 4. Меры по защите персональных данных

**4.1.** Платформа реализует технические, программные и организационные меры защиты персональных данных в соответствии с требованиями законодательства Республики Беларусь.

**4.2.** Персональные данные обрабатываются с использованием сертифицированных средств защиты информации.

**4.3.** Все сотрудники Платформы, имеющие доступ к персональным данным, подписывают обязательства о конфиденциальности.

**4.4.** В случае возникновения угрозы или факта нарушения защиты персональных данных Платформа незамедлительно уведомляет операторов и предпринимает меры по устранению последствий.

## 5. Передача персональных данных

**5.1.** Передача персональных данных третьим лицам возможна только по поручению и с согласия оператора.

**5.2.** Трансграничная передача персональных данных осуществляется в строгом соответствии с законодательством Республики Беларусь.

## 6. Заключительные положения

**6.1.** Настоящая Политика размещается в открытом доступе на сайте Платформы.

**6.2.** Изменения в Политику конфиденциальности вносятся в соответствии с законодательством Республики Беларусь.  

##

Настоящая политика конфиденциальности разработана в соответствии с **Законом Республики Беларусь «О защите персональных данных» от 7 мая 2021 г. № 99-З** и вступает в силу с момента её публикации на сайте Продукта.

**ООО «Кэтлоджик»**  
Юридический адрес: Республика Беларусь, г. Минск, 220073, ул. Харьковская, д. 15, пом. 311
`;
